import { isFunction, isPlainObject, isPromise } from 'es-toolkit';
export class Singleton {
    #instance;
    ready;
    isReady = false;
    constructor() {
        if (!('init' in this) || typeof this.init !== 'function') {
            throw new Error('Singleton requires an init method to be defined.');
        }
        this.#init();
        return new Proxy(this, {
            get: this.#proxyGetter,
            set: this.#proxySetter,
        });
    }
    #proxyGetter = (target, prop, receiver) => {
        if (prop in target) {
            const resolvedReceiver = prop === 'instance' ? target : receiver;
            return Reflect.get(target, prop, resolvedReceiver);
        }
        if (target.#instance && prop in target.#instance) {
            const inst = target.#instance;
            const value = inst[prop];
            return !isPlainObject(inst) && isFunction(value)
                ? value.bind(inst)
                : value;
        }
    };
    #proxySetter = (target, prop, value, receiver) => {
        if (!this.#instance || prop in target) {
            return Reflect.set(target, prop, value, receiver);
        }
        if (target.#instance && prop in target.#instance) {
            target.#instance[prop] = value;
            return true;
        }
        return false;
    };
    #init() {
        const { promise, resolve } = Promise.withResolvers();
        const originalInit = this.init.bind(this);
        this.ready = promise;
        this.init = (...args) => {
            const initReturnValue = originalInit(...args);
            if (!isPromise(initReturnValue)) {
                this.#instance = initReturnValue;
                this.isReady = true;
                resolve();
                return;
            }
            return initReturnValue.then((instance) => {
                this.#instance = instance;
                this.isReady = true;
                resolve();
            });
        };
    }
    get instance() {
        return this.#instance;
    }
}
